export default "__VITE_ASSET__xsYqKvMT__"